import React, { useEffect, useState } from "react";
import { Col, Button, Form, Spinner, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import "../css/BrokerForm.css";
import axios from "axios";
import { setErrorInBrokerForm } from "../store/actions";
import Consent from "./Consent";
import { contactUsTitleLine } from "../Utils/WHL/helpers";

const BrokerForm = ({ isFormSubmitSuccess }) => {
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [firstLastNameErrMsg, setFirstLastNameErrMsg] = useState(false);
  const [telephoneEmailErrMsg, setTelephoneEmailErrMsg] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showConsenSection, setShowConsenSection] = useState(false);
  const [showContactForm, setShowContactForm] = useState(true);
  const [companyName, setCompanyName] = useState("");
  const [formLoading, setFormLoading] = useState(false);
  const [showTY, setTYModal] = useState(false);
  const [showFail, setFailModal] = useState(false);
  const [honeyPot, setHoneyPot] = useState(false);
  const dispatch = useDispatch();

  const [consent, setConsent] = useState(false);
  const [submitClickDone, setSubmitClickDone] = useState(true);
  const [agreed, setAgreed] = useState(true);

  const goBackToFirstPage = () => setShowConsenSection(false);

  const handleConsentClick = (e, flag) => {
    if (flag) {
      setAgreed(true);
    } else {
      setAgreed(false);
    }
  };

  const handleConsentCheck = (e) => {
    setConsent(e.target.checked);
  };

  useEffect(() => {
    dispatch(setErrorInBrokerForm(firstLastNameErrMsg || telephoneEmailErrMsg));
  }, [firstLastNameErrMsg || telephoneEmailErrMsg]);

  function trim(theStr) {
    return theStr.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
  }

  function handleTYClose() {
    // window.location.reload(false);
    setTYModal(false);
  }

  const handleFailClose = () => setFailModal(false);

  function getNumbers(inVal, isDouble, removeCharsFromPrefix) {
    var retVal = "";
    var okChars = "0123456789";
    var tmpVal = trim(inVal);
    var curChar = "";
    var isDotFound = false;

    if (tmpVal !== "") {
      for (var i = 0; i < tmpVal.length; i++) {
        curChar = tmpVal.charAt(i);

        if (okChars.indexOf(curChar) !== -1) {
          if (!isDotFound && curChar === "." && isDouble) {
            isDotFound = true;
            retVal = retVal + ".";
          }

          if (retVal === "" && removeCharsFromPrefix.indexOf(curChar) !== -1) {
            //Do nothing
          } else {
            retVal += curChar;
          }
        }
      }
    }

    return retVal;
  }

  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  function getFormURL() {
    if (
      window.location.href.split("/")[3] &&
      window.location.href.split("/")[4]
    ) {
      const temp = window.location.href.split("/")[4].replace("#", "");
      return "/" + window.location.href.split("/")[3] + "/" + temp;
    } else {
      return "/";
    }
  }

  function handleClose() {
    let contactForm = document.getElementById("frmContact");
    contactForm.classList.remove("was-validated");
    setValidated(false);
    setShow(false);
  }

  function serialize(form) {
    let inputs = form.elements;
    let testArray = {};
    for (let i = 0; i < inputs.length - 1; i++) {
      testArray[inputs[i].id] = inputs[i].value;
    }
    return testArray;
  }

  function resetFrmContactForm() {
    document.getElementById("firstName").value = "";
    document.getElementById("lastName").value = "";
    document.getElementById("email").value = "";
    document.getElementById("companyName").value = "";
    document.getElementById("phone").value = "";
    setPhoneNumber("");
  }

  const handleFirstName_OnChange = (evt) => {
    if (
      evt.target.value.trim() === "" &&
      document.getElementById("lastName").value.trim() === ""
    ) {
      setFirstLastNameErrMsg(true);
      evt.target.setAttribute("required", "required");
      document.getElementById("lastName").setAttribute("required", "required");
    } else {
      setFirstLastNameErrMsg(false);
      if (evt.target.value.trim() !== "") {
        document.getElementById("lastName").removeAttribute("required");
      } else {
        if (document.getElementById("lastName").value.trim() === "") {
          document
            .getElementById("lastName")
            .setAttribute("required", "required");
        }
      }
    }
  };

  const handleLastName_OnChange = (evt) => {
    if (
      document.getElementById("firstName").value.trim() === "" &&
      evt.target.value.trim() === ""
    ) {
      setFirstLastNameErrMsg(true);
      document.getElementById("firstName").setAttribute("required", "required");
      evt.target.setAttribute("required", "required");
    } else {
      setFirstLastNameErrMsg(false);
      if (evt.target.value.trim() !== "") {
        document.getElementById("firstName").removeAttribute("required");
      } else {
        if (document.getElementById("firstName").value.trim() === "") {
          document
            .getElementById("firstName")
            .setAttribute("required", "required");
        }
      }
    }
  };

  //-- Checking error messages validations for Telephone and Email (either any one or both)
  const handleEmail_OnChange = (evt) => {
    if (
      evt.target.value.trim() === "" &&
      document.getElementById("phone").value.trim() === ""
    ) {
      setTelephoneEmailErrMsg(true);
      evt.target.setAttribute("required", "required");
      document.getElementById("phone").setAttribute("required", "required");
    } else {
      setTelephoneEmailErrMsg(false);
      if (evt.target.value.trim() !== "") {
        document.getElementById("phone").removeAttribute("required");
      } else {
        if (evt.target.value.trim() === "") {
          evt.target.setAttribute("required", "required");
        }
      }
    }
  };

  const handleTelephoneNumber = (evt) => {
    //Save Phone number in local storage for Apply
    var tmpVal = trim(getNumbers(evt.target.value, false, "01"));
    var FirstThreeDigit = tmpVal.substring(0, 3);
    var FirstSixDigit = tmpVal.substring(0, 6);

    /* Below Pattern will check numbers between below ranges
            456, 555, 900,
            100, 101, ..., 199
            211, 311, ..., 911  ***811 removed
            370, 371, ..., 379
            960, 961, ..., 969
            800, 801, ..., 855  ***removed
            866, 877, 888, 800855
            */
    var patt =
      /^(1[0-9][0-9])|([2-7]11)|(911)|(37[0-9])|(96[0-9])|(456)|(555)|(866)|(877)|(888)|(900)$/;
    var patt2 = /^800855$/;
    if (patt.test(FirstThreeDigit)) {
      evt.target.value = "";
      return;
    } else if (patt2.test(FirstSixDigit)) {
      evt.target.value = "";
      return;
    }

    var curChar = "";

    var areaCode = "";
    var firstThree = "";
    var lastFour = "";
    var extension = "";

    if (tmpVal !== "") {
      for (var i = 0; i < tmpVal.length; i++) {
        curChar = tmpVal.charAt(i);

        if (i < 3) areaCode += curChar;
        if (i < 6 && i > 2) firstThree += curChar;
        if (i < 10 && i > 5) lastFour += curChar;
        if (i > 9) extension += curChar;
      }
    }

    var retVal = "";

    /* 6/13/2020 - Dennis
          Do not put the parentesis if we only have the first three digits of the phone number.
          Once we are past that then start formatting the phone number. This was the main issue
          why the phone number couldn't be blanked out in it's entirety.
        */
    if (areaCode !== "" && firstThree === "") retVal += areaCode;
    else if (areaCode !== "" && firstThree !== "")
      retVal += "(" + areaCode + ")";

    if (firstThree !== "") retVal += " " + firstThree;

    if (lastFour !== "") retVal += "-" + lastFour;

    if (extension !== "") retVal += " x" + extension;
    else setPhoneNumber(retVal);
    //-- Checking error messages validations for Telephone and Email (either any one or both)
    if (
      document.getElementById("email").value.trim() === "" &&
      evt.target.value.trim() === ""
    ) {
      setTelephoneEmailErrMsg(true);
      document.getElementById("email").setAttribute("required", "required");
      evt.target.setAttribute("required", "required");
    } else {
      setTelephoneEmailErrMsg(false);
      if (evt.target.value.trim() !== "") {
        document.getElementById("email").removeAttribute("required");
      } else {
        if (evt.target.value.trim() === "") {
          evt.target.setAttribute("required", "required");
        }
      }
    }
    //--end
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    const dataToCheck = document.querySelector("#frmContact");
    const getDataToCheck = serialize(dataToCheck);

    if (
      getDataToCheck.firstName.trim() === "" &&
      getDataToCheck.lastName.trim() === ""
    ) {
      document.getElementById("firstName").setAttribute("required", "required");
      document.getElementById("lastName").setAttribute("required", "required");
      setFirstLastNameErrMsg(true);
    } else {
      setFirstLastNameErrMsg(false);
      if (getDataToCheck.firstName.trim() === "") {
        document.getElementById("firstName").removeAttribute("required");
      } else {
        document.getElementById("lastName").removeAttribute("required");
      }
    }
    if (
      getDataToCheck.email.trim() === "" &&
      getDataToCheck.phone.trim() === ""
    ) {
      document.getElementById("email").setAttribute("required", "required");
      document.getElementById("phone").setAttribute("required", "required");
      setTelephoneEmailErrMsg(true);
    } else {
      setTelephoneEmailErrMsg(false);
      if (getDataToCheck.email.trim() === "") {
        document.getElementById("email").removeAttribute("required");
      } else {
        document.getElementById("phone").removeAttribute("required");
      }
    }

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {

      setFormLoading(true);
      setSubmitClickDone(false);

      if (!showConsenSection) {
        const data = document.querySelector("#frmContact");
        const getData = serialize(data);
        let contactForm = document.getElementById("frmContact");
        const firstName_ = getData.firstName;
        const lastName_ = getData.lastName;
        const phoneNumber_ = getData.phone;
        const email_ = getData.email;
        const companyName_ = getData.companyName;
        const utmSource = getParameterByName("utm_source") || undefined;
        const utmMedium = getParameterByName("utm_medium") || undefined;
        const utmCampaign = getParameterByName("utm_campaign") || undefined;
        const utmContent = getParameterByName("utm_content") || undefined;
        let formUrl = getFormURL();
        const chs_name = getData["chs:name"];

        axios
          .post(process.env.REACT_APP_API_EMAIL, {
            firstName: firstName_,
            lastName: lastName_,
            phone: phoneNumber_,
            email: email_,
            companyName: companyName_,
            "chs:name": chs_name,
            utmSource: utmSource,
            utmMedium: utmMedium,
            utmCampaign: utmCampaign,
            utmContent: utmContent,
            formUrl: formUrl,
            leadSource: "WHL",
            TCPA_Consent_Given: agreed,
          })
          .then((res) => {
            setTYModal(false);
            setFormLoading(false);
            contactForm.classList.remove("was-validated");
            setSubmitClickDone(true);
            isFormSubmitSuccess(false);
            setShowConsenSection(true);
          })
          .catch(function (error) {
            handleClose();
            setFailModal(true);
            contactForm.classList.remove("was-validated");
            contactForm.reset();
            resetFrmContactForm();
            setFormLoading(false);
            setSubmitClickDone(true);
            isFormSubmitSuccess(false);
          });

      } else {
        const data = document.querySelector("#frmContact");
        const getData = serialize(data);
        let contactForm = document.getElementById("frmContact");
        const firstName_ = getData.firstName;
        const lastName_ = getData.lastName;
        const phoneNumber_ = getData.phone;
        const email_ = getData.email;
        const companyName_ = getData.companyName;
        const utmSource = getParameterByName("utm_source") || undefined;
        const utmMedium = getParameterByName("utm_medium") || undefined;
        const utmCampaign = getParameterByName("utm_campaign") || undefined;
        const utmContent = getParameterByName("utm_content") || undefined;
        let formUrl = getFormURL();
        const chs_name = getData["chs:name"];

        axios
          .post(process.env.REACT_APP_API_EMAIL, {
            firstName: firstName_,
            lastName: lastName_,
            phone: phoneNumber_,
            email: email_,
            companyName: companyName_,
            "chs:name": chs_name,
            utmSource: utmSource,
            utmMedium: utmMedium,
            utmCampaign: utmCampaign,
            utmContent: utmContent,
            formUrl: formUrl,
            leadSource: "WHL",
            TCPA_Consent_Given: agreed,
          })
          .then((res) => {
            handleClose();
            setTYModal(true);
            setShowConsenSection(false);
            setShowContactForm(true);
            resetFrmContactForm();
            contactForm.classList.remove("was-validated");
            contactForm.reset();
            setFormLoading(false);
            setSubmitClickDone(true);
            isFormSubmitSuccess(true);
          })
          .catch(function (error) {
            handleClose();
            setFailModal(true);
            contactForm.classList.remove("was-validated");
            contactForm.reset();
            resetFrmContactForm();
            setFormLoading(false);
            setSubmitClickDone(true);
            isFormSubmitSuccess(false);
          });

      }
    }
    setValidated(true);
  };

  function changeClass(ename) {
    ename.target.className = "form-control";
  }

  const handleGetStarted = (event) => {
    event.preventDefault();

    const form = document.querySelector("#frmContact");
    const dataToCheck = document.querySelector("#frmContact");
    const getDataToCheck = serialize(dataToCheck);
    if (
      getDataToCheck.firstName.trim() === "" &&
      getDataToCheck.lastName.trim() === ""
    ) {
      document.getElementById("firstName").setAttribute("required", "required");
      document.getElementById("lastName").setAttribute("required", "required");
      setFirstLastNameErrMsg(true);
    } else {
      setFirstLastNameErrMsg(false);
      if (getDataToCheck.firstName.trim() === "") {
        document.getElementById("firstName").removeAttribute("required");
      } else {
        document.getElementById("lastName").removeAttribute("required");
      }
    }
    if (
      getDataToCheck.email.trim() === "" &&
      getDataToCheck.phone.trim() === ""
    ) {
      document.getElementById("email").setAttribute("required", "required");
      document.getElementById("phone").setAttribute("required", "required");
      setTelephoneEmailErrMsg(true);
    } else {
      setTelephoneEmailErrMsg(false);
      if (getDataToCheck.email.trim() === "") {
        document.getElementById("email").removeAttribute("required");
      } else {
        document.getElementById("phone").removeAttribute("required");
      }
    }
    if (form.checkValidity() === false) {

      event.stopPropagation();
      form.classList.add("was-validated");
    } else {

      setShowConsenSection(true);
    }
  };

  // jsx
  return (
    <div className="broker-form-container">
      <div className="form-titles-section">
        <>
          <h4 className="modal-title text-center roboto_bold">
            {`${contactUsTitleLine}:`}
          </h4>
          <div className="text-center roboto_regular title-line">
            60 Seconds to Sign up -
          </div>
          <div className="text-center bottommost_text roboto_regular title-line">
            Your Loans Will Be Thoroughly Reviewed & Underwritten On Demand
          </div>
        </>
      </div>
      <>
        {showContactForm && (
          <Form
            className="need-validation"
            id="frmContact"
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
          // onSubmit={() => {
          //     handleClose();
          //     setTYModal(true);
          //     resetFrmContactForm();
          //     setFormLoading(false);

          //     /** WHL-50 */
          //     isFormSubmitSuccess(true)
          // }}
          >
            <Form.Row className="treasury">
              <Form.Group as={Col} className="px-0" controlId="chs:name">
                <strong>
                  <Form.Label>* Get Quote Name: </Form.Label>
                </strong>
                <Form.Control
                  type="text"
                  minLength="2"
                  maxLength="12"
                  onChange={(e) => setHoneyPot(true)}
                  data-error="Please fill out this field correctly."
                />
                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
              </Form.Group>
            </Form.Row>
            <Form.Row className="treasury">
              <Col className="">
                <Form.Group as={Col} className="px-0" controlId="quote_code">
                  <strong>
                    <Form.Label>* Get Quote Code: </Form.Label>
                  </strong>
                  <Form.Control
                    type="text"
                    pattern="^[0-9a-zA-Z]{4}$"
                    maxLength="4"
                    onChange={(e) => setHoneyPot(true)}
                    data-error="Please fill out this field correctly."
                  />
                  <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Form.Row>
            <Form.Row>
              <Col className="fname px-0">
                <Form.Group as={Col} className="px-0" controlId="firstName">
                  <Form.Label srOnly>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                    className={showConsenSection ? "d-none" : "d-block"}
                    // value={firstName}
                    required
                    onChange={(e) => handleFirstName_OnChange(e)}
                  />
                </Form.Group>
              </Col>
            </Form.Row>
            <Form.Row className="lname">
              <Col className="px-0">
                <Form.Group as={Col} className="px-0" controlId="lastName">
                  <Form.Label srOnly>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="lastName"
                    required
                    placeholder="Last Name"
                    className={showConsenSection ? "d-none" : "d-block"}
                    // value={lastName}
                    onChange={(e) => handleLastName_OnChange(e)}
                  />
                </Form.Group>
              </Col>
            </Form.Row>
            <Form.Row className="temp">
              <Col className="px-0">
                <Form.Group as={Col} className="px-0" controlId="companyName">
                  <Form.Label srOnly>Company Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="companyName"
                    placeholder="Company Name"
                    className={showConsenSection ? "d-none" : "d-block"}
                  // value={companyName}
                  // onChange={(e) => {
                  //     e.preventDefault()
                  //     setCompanyName(e.target.value);
                  // }}
                  />
                </Form.Group>
              </Col>
            </Form.Row>

            <Form.Row className="">
              <Col className="px-0">
                <Form.Group as={Col} className="px-0" controlId="email">
                  <Form.Label srOnly>Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    className={showConsenSection ? "d-none" : "d-block"}
                    // value={email}
                    required
                    onChange={handleEmail_OnChange}
                  />
                </Form.Group>
              </Col>
            </Form.Row>
            <Form.Row>
              <Col className="px-0">
                <Form.Group as={Col} className="px-0" controlId="phone">
                  <Form.Label srOnly>Telephone</Form.Label>
                  <Form.Control
                    style={{ textAlign: "left" }}
                    className={`${showConsenSection ? "d-none" : "d-block"} contact-form-field`}
                    type="text"
                    name="phone"
                    placeholder="Telephone Number"
                    minLength={14}
                    maxLength={21}
                    pattern="^\(?(\d{3})\)?-?\s?(\d{3})-?\s?(\d{4})[ ]*(( |x){1}[ ]?([0-9]){1,7}){0,1}$"
                    onChange={handleTelephoneNumber}
                    onFocus={changeClass.bind(this)}
                    autoComplete="off"
                    value={phoneNumber}
                    required
                  />
                </Form.Group>
              </Col>
            </Form.Row>
            {/* WHL-71: old consent hidden */}

            <Form.Row className={`consent-div pt-2 ${showConsenSection ? "d-none" : "d-block"}`}>
              <p className="consent-title mb-1"></p>
              <p className="terms-div">
                By clicking Get Started below you agree to Sun West Mortgage Company,
                Inc.'s NMLS 3277 ("Sun West"){" "}<a
                  href="https://www.swmc.com/terms-and-conditions"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms and Conditions
                </a>{" "}
                and{" "}
                <a
                  href="https://www.swmc.com/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Security and Privacy Policy
                </a>
                ;{" "} and you agree to Celligence International, LLC.'s ("Celligence"){" "}
                <a
                  href="https://www.celligence.com/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms and Conditions
                </a>{" "}
                and{" "}
                <a
                  href="https://www.celligence.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Security and Privacy Policy
                </a>
                , all of which you may access by clicking on the "Terms and
                Conditions" or "Security Policy" web links contained herein.
              </p>
            </Form.Row>

            <Form.Row className={`consent-div consent-v2 ${showConsenSection ? "d-block" : "d-none"}`}>
              <Consent

                agreed={agreed}
                submitClickDone={submitClickDone}
                isChecked={consent}
                handleConsentClick={handleConsentClick}
              />
            </Form.Row>
            {firstLastNameErrMsg && (
              <Col md={12} className="tcpa validationMsges px-0">
                <div className="pb-0 px-0 redAst errMsgForPair">
                  Please provide at least your first name or last name.
                </div>
              </Col>
            )}
            {telephoneEmailErrMsg && (
              <Col md={12} className="tcpa validationMsges px-0">
                <div className="pb-0 px-0 redAst errMsgForPair">
                  Please provide at least your email address or telephone number.
                </div>
              </Col>
            )}
            <Col className={`px-0 pt-1 btnSubmit-Col text-center ${showConsenSection ? "d-none" : "d-block"}`}>
              <Button className="btnSubmit" type="submit" onClick={handleGetStarted}>
                {formLoading ? (
                  <div className="smlsLoader">
                    <Spinner
                      as="span"
                      animation="border"
                      size="md"
                      role="status"
                      aria-hidden="true"
                    />
                    <span>{` Please wait...`}</span>
                  </div>
                ) : (
                  "Get Started"
                )}
              </Button>
            </Col>
            <Col
              className={showConsenSection ? "d-block" : "d-none"}
            >
              <div className="divflexchanges">
                <div className="backBtnDiv">
                  <Button
                    className="btnSubmit"
                    type="button"
                    onClick={goBackToFirstPage}
                  >
                    <>Back</>
                  </Button>
                </div>
                <div className="continueBtnDiv btnAdjustDiv">
                  <Button
                    className="btnSubmit"
                    type="submit"
                  >
                    {formLoading ? (
                      <>
                        <Spinner
                          animation="border"
                          aria-hidden="true"
                          as="span"
                          role="status"
                          size="sm"
                        />{" "}
                        Please wait...
                      </>
                    ) : (
                      <>Continue</>
                    )}
                  </Button>
                </div>
              </div>
            </Col>
          </Form>
        )}
      </>
      <Modal
        size="lg"
        centered
        show={showTY}
        onHide={handleTYClose}
        backdrop="static"
        className="aqua-theme-wrapper"
      >
        <Modal.Header className="aqua-theme-title-section">
          {/* <h4 className="text-white"></h4> */}
          <Modal.Title className="text-center py-2">Thank You!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="modal-text-content mb-0">
            Thank you for contacting<br></br> Sun West Mortgage Company, Inc.
            <br></br> We will respond to your message<br></br> as soon as
            possible.
          </p>
          <Button className="close-btn" onClick={handleTYClose}>
            Close
          </Button>
        </Modal.Body>
      </Modal>
      <Modal
        size="lg"
        centered
        show={showFail}
        onHide={handleFailClose}
        backdrop="static"
      >
        <Modal.Body>
          Due to technical difficulties your request could not be processed.
          Please contact <a href="mailto:CSSTeam@swmc.com">CSSTeam@swmc.com</a>.
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleFailClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BrokerForm;
